import React from 'react';
import { FaSave, FaRegCheckSquare, FaArrowUp } from 'react-icons/fa';
import { BiSolidSelectMultiple } from 'react-icons/bi';
import { RiDeleteBin6Line } from 'react-icons/ri';

export const SpreadSheetActions = ({
  count,
  setCount,
  sheetData,
  setSheetData,
  saveSheetData,
  hideItemListPopup,
  singleRowAdd,
  createEmptySheetRows,
  activeCell,
  t
}) => {

  function insertRowAbove(e){
    if (activeCell &&((Array.isArray(activeCell) && activeCell.length === 0) ||(!Array.isArray(activeCell) && Object.keys(activeCell).length === 0))) return;      
    const index=activeCell.row;
    let updatedDataSheet = JSON.parse(JSON.stringify( sheetData ));
    const updatedRow = singleRowAdd.map(cell => {
        const updatedClass = cell.className?.replace(/cellClass_\d+_(\d+)/g, `cellClass_${index}_$1`);
        return {
          ...cell,
          className: updatedClass ?? cell.className
        };
      });
      updatedDataSheet.splice(index,0,[...updatedRow]);
      const rowindexedData = updatedDataSheet.map((row, rowIndex) => {
        return row.map(cell => {
          const updatedClassName = cell.className?.replace(/cellClass_\d+_(\d+)/g, `cellClass_${rowIndex}_$1`);
          return {
            ...cell,
            className: updatedClassName ?? cell.className
          };
        });
      });
     setSheetData([...rowindexedData])

}

  function selectAllCells(e){
    setCount((prev)=>prev+1)
    let updatedSheetData=[]
    let isFixedfieldsExist=false;
    if(count%2!==0){
        updatedSheetData = sheetData.map((row, rowIndex) => {
            return row.map((cell, colIndex) => {
                isFixedfieldsExist = cell.className?.includes('fixedfields');
                return {
                    ...cell,
                    className: `selectcell-class cellClass cellClass_${rowIndex}_${colIndex}${isFixedfieldsExist ? ' fixedfields' : ''}`
                };
            });
        });
    }else{
        updatedSheetData = sheetData.map((row, rowIndex) => {
            return row.map((cell, colIndex) => {
                isFixedfieldsExist = cell.className?.includes('fixedfields');
                return {
                    ...cell,
                    className: `cellClass cellClass_${rowIndex}_${colIndex}${isFixedfieldsExist ? ' fixedfields' : ''}`
                };
            });
        });
    }

    setSheetData(updatedSheetData);

};

function removeRow() {
  hideItemListPopup();
  let jsonSpreadsheetData = JSON.stringify(sheetData);
  let inSheetData = JSON.parse(jsonSpreadsheetData);
  if(count%2 === 0){
    const newRows = createEmptySheetRows(10,[]);
    setSheetData([...newRows])
}else if ( count%2 !== 0 && Object.keys(activeCell).length === 0) {
    inSheetData.pop();
    setSheetData([...inSheetData]);
  } else {
    let selectedRowIndex = activeCell.row;
    if (selectedRowIndex || selectedRowIndex === 0) {
      inSheetData.splice(selectedRowIndex, 1);
      setSheetData([...inSheetData]);
    }
  }
}

  return(
    <div className="leftBlock alignItemsCenter flexRow">
      <button
        onClick={(e) => saveSheetData(e)}
        className="alignItemsCenter add-item-button"
      >
        <FaSave style={{ marginRight: '5px' }} />
        {t('buttons.save')}
      </button>
      &nbsp;
      <button
        onClick={(e) => {
          e.stopPropagation();
          selectAllCells(e);
        }}
        className="alignItemsCenter flexRow add-item-button-all m-3"
      >
        {count % 2 === 0 ? (
          <BiSolidSelectMultiple style={{ marginRight: '5px' }} />
        ) : (
          <FaRegCheckSquare style={{ marginRight: '5px' }} />
        )}
        Select All
      </button>
      <button
        onClick={(e) => removeRow(e)}
        className="alignItemsCenter flexRow remove-button"
      >
        <RiDeleteBin6Line style={{ marginRight: '5px' }} />
        {t('buttons.deleteRows')}
      </button>
      <button
        onClick={(e) => {
          e.stopPropagation();
          insertRowAbove(e);
        }}
        className="alignItemsCenter flexRow insert-button"
      >
        <FaArrowUp style={{ marginRight: '5px' }} />
        {t('buttons.insertRows')}
      </button>
    </div>
  );
}



